import {
  Autocomplete,
  Checkbox,
  FormControl,
  FormControlLabel,
  Stack,
  TextField,
} from "@mui/material";

import { StateOption } from "../types";

interface StateRuleFieldsProps {
  value: string;
  inputValue: string;
  stateOptions: StateOption[];
  onInputChange: (value: string) => void;
  onChange: (value: string) => void;
  // For state revision allow rules
  isStateRevisionAllow?: boolean;
  needsCandidate?: boolean;
  notImplemented?: boolean;
  onNeedsCandidateChange?: (checked: boolean) => void;
  onNotImplementedChange?: (checked: boolean) => void;
}

/**
 * Field component for state-based rules (Allow State, Allow State Revision)
 */
export function StateRuleFields({
  value,
  inputValue,
  stateOptions,
  onInputChange,
  onChange,
  isStateRevisionAllow = false,
  needsCandidate = false,
  notImplemented = false,
  onNeedsCandidateChange,
  onNotImplementedChange,
}: StateRuleFieldsProps) {
  return (
    <FormControl fullWidth>
      <Autocomplete
        freeSolo
        options={stateOptions}
        value={value ? stateOptions.find((opt) => opt.value === value) || value : null}
        inputValue={inputValue}
        onInputChange={(_, newInputValue) => {
          onInputChange(newInputValue);
        }}
        onChange={(_, newValue) => {
          if (typeof newValue === "string") {
            onChange(newValue);
          } else if (newValue && typeof newValue === "object" && "value" in newValue) {
            onChange(newValue.value);
          } else {
            onChange("");
          }
        }}
        getOptionLabel={(option) => {
          if (typeof option === "string") {
            return option;
          }
          if (typeof option === "object" && "value" in option) {
            return option.label || option.value;
          }
          return "";
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="State/Territory"
            placeholder="Enter state code (e.g., CA) or select from list"
            helperText="You can enter any state code, including custom values"
          />
        )}
      />
      {isStateRevisionAllow && (
        <Stack direction="row" spacing={2} sx={{ mt: 1.5 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={needsCandidate}
                onChange={(e) => onNeedsCandidateChange?.(e.target.checked)}
              />
            }
            label="Needs Candidate"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={notImplemented}
                onChange={(e) => onNotImplementedChange?.(e.target.checked)}
              />
            }
            label="Not Implemented"
          />
        </Stack>
      )}
    </FormControl>
  );
}
